import { z } from "zod";

import { LoggerLevels } from "@north-beam/nb-client-side/analytics";

import environments from "./environments.json";

export const Environments = [
  "prod",
  "prod-staging",
  "prod-canary-cloudrun",
  "prod-alt",
  "dev",
  "prod-local",
  "prod-local-proxy",
  "dev-local",
  "dev-local-proxy",
] as const;

export type Env = (typeof Environments)[number];

const Environment = z.object({
  isDemoEnvironment: z.boolean(),
  isDevelopmentEnvironment: z.boolean(),
  amplitudeApiKey: z.string(),
  bugsnagApiKey: z.string(),
  datadogApplicationId: z.string().nullable(),
  datadogClientToken: z.string().nullable(),
  apiRoot: z.string(),
  heavyApiRoot: z.string().optional(),
  cpuIntensiveApiRoot: z.string().optional(),
  jobManagerApiRoot: z.string().optional(),
  auth0Domain: z.string(),
  auth0ClientId: z.string(),
  auth0Audience: z.string(),
  stripePublishableKey: z.string(),
  isNBInternal: z.boolean().optional(),
  prettyLog: z.boolean().optional(),
  logLevel: LoggerLevels.schema.optional(),
  /* Setting this flag to false will effectively turn off event logging to Amplitude.  It is treated
     as 'true' by default in production environments. */
  emitLogEventsToAmplitude: z.boolean().optional(),
  emitLogEventsToBrowser: z.boolean().optional(),
});

const nbEnv: Env = (process.env.REACT_APP_NB_ENV || "dev") as Env;
const config = Environment.parse(environments[nbEnv]);

export default config;
export const envName = nbEnv;
